import { Button, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { DonorInfoFragment, useDeleteDonorMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type DonorDetailMenuProps = {
  donor: DonorInfoFragment;
  onEdit: () => void;
};

const DonorDetailMenu = ({ donor, onEdit }: DonorDetailMenuProps) => {
  const history = useHistory();
  const [deleteDonor, { loading: deleting }] = useDeleteDonorMutation({
    variables: {
      id: donor.id,
    },
    onCompleted: () => {
      AppToaster.success(`${donor.name}  wurde in den Papierkorb gelegt`);
      history.goBack();
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem text="In den Papierkorb" icon={IconNames.TRASH} onClick={deleteDonor as any} />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default DonorDetailMenu;
